import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VideoSettingsDto } from '@client/shared/models/video-settings.dto';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class VideoSettingsApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/video-settings`;
  }

  getVideoSettings(): Observable<VideoSettingsDto> {
    return this.#http.get<VideoSettingsDto>(`${this.endpoint}`);
  }

  updateVideoSettings(isSkippingVideoExplanationEnabled: boolean): Observable<void> {
    return this.#http.put<void>(`${this.endpoint}`, { isSkippingVideoExplanationEnabled });
  }
}
